import React, { useEffect } from 'react'
import { allServices, projects, resumeJobs, wordList } from '../projects'
import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import Grid from '@mui/material/Grid';
import SplitType from 'split-type'
import { Flip, ScrollTrigger, TextPlugin } from 'gsap/all';
import jack from '../images/One-Eyed-Jack-Tattoo-Illustration.png'
import queen from '../images/Queen-of-Swords-Tattoo-Illustration.png'
import logoBlack from '../images/E-INC-LOGO.webp'
import { Box, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import logoIcon from '../images/services/Logo-and-Branding-Pen-Tool.svg'
import gridIcon from '../images/services/Logo-and-Branding-Grid.svg'
import userExpIcons from '../images/services/User-Interface-and-User-Experience-Monitor.svg'
import userPic from '../images/services/User-Interface-and-User-Experience-Image-Filler.svg'
import placeholderIcon from '../images/services/User-Interface-and-User-Experience-Responsive-Image.svg'
import artsIcons from '../images/services/Fine-Arts-Paintbrush.svg'
import paletteIcon from '../images/services/Fine-Arts-Palette.svg'
import motionSlider from '../images/services/Motion-Graphics-Timeline-Tool.svg'
import motionIcons from '../images/services/Motion-Graphics-Background.svg'

import '../styles/Home.scss'

export const Home = ({ setShowGallery, setSelectedProject, setProjIndex }) => {
    gsap.registerPlugin(useGSAP);
    gsap.registerPlugin(Flip)
    gsap.registerPlugin(ScrollTrigger)
    gsap.registerPlugin(TextPlugin)

    const container = useRef();

    useGSAP(
        () => {
            var tl = gsap.timeline();
            const ourText = new SplitType('#about', { types: 'words, chars' })
            const chars = ourText.chars

            tl.from(chars, {
                duration: 0.8,
                opacity: 0,
                scale: 0,
                y: 80,
                rotationX: 180,
                transformOrigin: "0% 50% -50",
                ease: "back",
                stagger: 0.01
            });

            var tl2 = gsap.timeline();
            const ourText2 = new SplitType('.word', { types: 'words, chars' })
            const chars2 = ourText2.chars

            tl2.from(chars2, {
                duration: 0.8,
                opacity: 0,
                scale: 0,
                y: 80,
                rotationX: 180,
                transformOrigin: "0% 50% -50",
                ease: "back",
                stagger: 0.01
            });

            const galleryWrapper = document.querySelector('.gallerySection')
            const gallery = document.querySelector('.gallery')

            const tl3 = gsap.timeline()
            tl3.to(gallery, {
                x: `-${gallery.offsetWidth}`,
                scrollTrigger: {
                    trigger: galleryWrapper,
                    start: 'top top',
                    end: `+=${gallery.offsetWidth}`,
                    pin: true,
                    scrub: 0.5,
                }
            })

            const textLines = document.querySelectorAll(".quote");

            var cardTL = gsap.timeline({
                yoyo: false,
                scrollTrigger: {
                    trigger: '.quoteContainer',
                    markers: false,
                }
            });

            cardTL.from('.jackCard', {
                x: -1000
            })

            cardTL.from('.queen', {
                x: 1000
            })

            const textLineAnim = gsap.timeline({
                defaults: {
                    duration: 2,
                    ease: 'none'
                },
                scrollTrigger: {
                    trigger: '.quoteContainer',
                    // end: "bottom center",
                    scrub: 0.5,
                    markers: false
                }
            })

            textLineAnim
                .fromTo(textLines, {
                    x: (index, target) => index % 2 ? window.innerWidth : -window.innerWidth,
                    fontStyle: 'normal'
                }, {
                    x: 0,
                    fontStyle: 'italic'
                }, 0)
                .fromTo(textLines, {
                    x: 0,
                    fontStyle: 'italic'
                }, {
                    x: (index, target) => index % 2 ? -window.innerWidth : window.innerWidth,
                    immediateRender: false,
                    fontStyle: 'normal'
                }, 2)


            let boxes = gsap.utils.toArray("#services .serviceCard")
            let container2 = document.querySelector("#services"),
                text = document.querySelector("#text"),
                padding = gsap.getProperty(container2, "paddingTop", "px"),
                // create a ScrollTrigger for each box that we can use to calculate snapping (we'll look at the "start" of each in the onRefresh)
                snapTriggers = boxes.map(box => ScrollTrigger.create({
                    trigger: box,
                    markers: false,
                    start: "top " + padding + "px"
                })),
                snaps = []; // where we'll store the progress value for each box's ScrollTrigger (start)

            ScrollTrigger.create({
                trigger: '#services',
                markers: false,
                pin: '#text',
                pinSpacing: false,
                start: 250 + " center",
                end: () => "+=" + (boxes[boxes.length - 1].getBoundingClientRect().top - boxes[0].getBoundingClientRect().top),
                onRefresh: self => {
                    // re-populate the "snaps" Array with the progress values for where each box hits the target spot.
                    let distance = self.end - self.start;
                    snapTriggers.forEach((trigger, i) => snaps[i] = (trigger.start - self.start) / distance);
                },
                //snap: snaps
            });

            // for swapping in the text for each section


            // START LOGO PEN ANIMATION
            const logoTL = gsap.timeline({
                yoyo: true,
                repeat: -1,
                duration: 1.2,
                scrollTrigger: {
                    trigger: '#logo',
                    start: -50,
                    markers: false,
                }
            }).repeatDelay(2)

            logoTL.fromTo('#pen', {
                x: -32,
                y: -10,
                rotate: -25
            }, {
                x: 110,
                y: 50
            })
            logoTL.to('#dot2', {
                height: 15,
                width: 15,
                duration: 0,
            })
            logoTL.fromTo('#pen', {
                x: 110,
                y: 50,
                rotate: -25,
            }, {
                x: -5,
                y: 125,
                rotate: -65
            })
            logoTL.to('#dot3', {
                height: 15,
                width: 15,
                duration: 0
            })
            // END LOGO PEN ANIMATION

            // START GDLAYOUT ANIMATION

            // const graphicsTL = gsap.timeline({
            //     yoyo: false,
            //     repeat: -1,
            //     scrollTrigger: {
            //         trigger: '#graphics',
            //         markers: false,
            //     }
            // }).repeatDelay(1)


            // graphicsTL.add("startGD", "+=0")

            // graphicsTL.to('#graphicsText', {
            //     x: 15,
            // }, 'startGD')


            // graphicsTL.to('.textRectangle', {
            //     width: 100,
            //     stagger: .05
            // }, 'startGD')

            // graphicsTL.to('.textRectangle2', {
            //     width: 100,
            //     stagger: .05
            // }, 'startGD')

            // graphicsTL.to('#graphicsText', {
            //     text: "Title",
            //     fontWeight: 'bold'
            // }, 'startGD')

            //placeholder img
            // graphicsTL.from('#gdLayout', {
            //     scale: 0
            // }, 'startGD')

            // graphicsTL.to('#graphicsText', {
            //     x: 25,
            // })

            // graphicsTL.to('#graphicsText', {
            //     x: 50,
            // })

            // graphicsTL.to('#graphicsText', {
            //     x: 75,
            // })

            // graphicsTL.to('#graphicsText', {
            //     x: 60,
            // })



            // graphicsTL.add("gdRescale", "+=0")


            // graphicsTL.to('#graphicsText', {
            //     fontFamily: 'Helvetica'
            // })

            // graphicsTL.to('.textRectangle2', {
            //     width: 0,
            //     stagger: .05
            // })


            // graphicsTL.to('#graphicsText', {
            //     fontFamily: 'Times New Roman'
            // })

            // graphicsTL.to('#graphicsText', {
            //     fontFamily: 'Georgia'
            // })

            // graphicsTL.to('#graphicsText', {
            //     fontFamily: 'Bodoni'
            // })
            // graphicsTL.to('#graphicsText', {
            //     fontFamily: 'Veranda'
            // })

            // graphicsTL.to('.textRectangle', {
            //     width: 95,
            //     stagger: .05
            // })

            // graphicsTL.to('.textRectangle2', {
            //     width: 100,
            //     stagger: .05
            // })


            const uiTL = gsap.timeline({
                yoyo: true,
                repeat: -1,
                scrollTrigger: {
                    trigger: '#ux-holder',
                    markers: false,
                }
            }).repeatDelay(5)

            uiTL.add("startUI", "+=0")
            // uiTL.to('#lorem', {
            //     rotate: -90,
            //     fontSize: 21,
            //     textAlign: 'center',
            //     x: 0,
            //     y: 20,
            //     width: '50%'
            // })


            uiTL.to('#ux-holder', {
                rotate: 90,
                scale: .7
            }, 'startUI')

            uiTL.to('#userPic', {
                rotate: -90,
                x: -25,
                y: -4,
                scale: 1.3
            }, 'startUI')

            uiTL.to('#headerPlaceholder', {
                rotate: -90,
                scale: .6,
                height: 15,
                x: -118,
                y: 35
            }, 'startUI')

            uiTL.to('#uiBtn', {
                rotate: -90,
                scale: 1.8,
                y: -8,
                x: 12
            }, 'startUI')

            uiTL.to('.textRectangle', {
                width: 115,
                height: 10,
                rotate: -90
            }, 'startUI')

            uiTL.to('#text2', {
                x: 15,
                y: -44
            }, 'startUI')

            uiTL.to('#text3', {
                x: 33,
                y: -54
            }, 'startUI')

            uiTL.to('#text4', {
                x: 51,
                y: -64
            }, 'startUI')

            uiTL.to('#computerBar', {
                y: -90,
                x: 125,
                width: 20,
                height: 20,
                borderRadius: 15
            }, 'startUI')


            uiTL.to('.placeholder', {
                opacity: 0
            }, 'startUI')

            uiTL.to('.menuBar', {
                height: 1,
                width: 20,
                rotate: -90,
                x: 0,
                y: 115,
                opacity: 1
            }, 'startUI')

            uiTL.to('#fakeNav1', {
                x: -5,
                y: 115,

            }, 'startUI')
            uiTL.to('#fakeNav2', {
                x: -10,
                y: 115,

            }, 'startUI')


            const codeTL = gsap.timeline({
                yoyo: false,
                repeat: -1,
                scrollTrigger: {
                    trigger: '#code',
                    markers: false,
                }
            }).repeatDelay(1)


            codeTL.add("startCode", "+=0")

            codeTL.to('.highlight', {
                text: 'Initiate fake coding program.'
            })

            codeTL.to('.highlight2', {
                ease: 'none',
                text: 'Here is some text.'
            })

            codeTL.to('.highlight3', {
                ease: 'none',
                text: 'This is some fake code'
            })

            codeTL.to('.highlight4', {
                ease: 'none',
                text: 'Coding is so great.'
            })

            codeTL.to('.highlight5', {
                ease: 'none',
                text: 'Hello World.',
            })

            codeTL.to('.highlight6', {
                ease: 'none',
                text: 'This is real, this is me.',
            })

            codeTL.to('.highlight7', {
                ease: 'none',
                text: 'This is some fake code.',
            })

            codeTL.to('.highlight8', {
                ease: 'none',
                text: 'Hello World.',
            })

            // codeTL.to('.highlight9', {
            //     ease: 'none',
            //     text: 'Initiate fake coding program.',
            // })

            // codeTL.to('.highlight10', {
            //     ease: 'none',
            //     text: 'Initiate fake coding program.',
            // })

            // codeTL.to('.highlight12', {
            //     ease: 'none',
            //     text: 'This is some fake code',
            // })

            // codeTL.to('.highlight13', {
            //     ease: 'none',
            //     text: 'Coding is so great.',
            // })

            // codeTL.to('.highlight14', {
            //     ease: 'none',
            //     text: 'Hello World.',
            // })

            codeTL.to('.bar', {
                opacity: 0
            })

            codeTL.to('.helloWorld', {
                ease: 'none',
                opacity: 1,
            })
            codeTL.to('.world', {
                ease: 'none',
                opacity: 1,
            })


            const artTL = gsap.timeline({
                yoyo: true,
                repeat: -1,
                scrollTrigger: {
                    trigger: '#arts',
                    markers: false,
                }
            }).repeatDelay(1)


            artTL.to('#palatte', {
                rotate: -15
            })
            artTL.fromTo('#brush', {
                x: 75,
                y: -65,
                rotate: -15
            }, {
                x: 25,
                y: -30,
                rotate: 0
            })

            const motionTL = gsap.timeline({
                yoyo: true,
                repeat: -1,
                scrollTrigger: {
                    trigger: '#motion',
                    markers: false,
                }
            }).repeatDelay(1)

            motionTL.add("motion1", "+=0")

            motionTL.to("#slider", {
                x: 75
            }, 'motion1')

            motionTL.to("#ball", {
                x: 50,
                y: 40
            }, 'motion1')

            motionTL.add("motion2", "+=0")

            motionTL.to("#slider", {
                x: 135
            }, 'motion2')

            motionTL.to("#ball", {
                x: 125,
                y: 3
            }, 'motion2')

        },
        { scope: container }
    );

    return (
        <div id="content" className='Home container' ref={container}>
            <div className='home-section section'>
                <img src={logoBlack} width={200} alt='Esteban Inc. Logo' />
                <h1 className='word smallHeader'>Esteban Inc.</h1>
                <div className='subHeader'>
                    <WordFader words={wordList} />
                </div>
                <div id='about'>
                    <h3>Working in the creative industry for 10+ years.</h3>
                </div>
            </div>
            <div className='section gallerySection bigBanner' id="selectedWorks">
                <h3>SAMPLES</h3>
                {/* <h3 className="top">{hoverProj ? hoverProj.title : 'WORKS'}</h3> */}
                <div className='gallery'>
                    {projects.filter(y => y.selected).map((project, projInd) => (
                        <div className='gallery-box box square'
                            onClick={() => {
                                setProjIndex(projInd)
                                setSelectedProject(project)
                                setShowGallery(true)
                            }}
                            key={"project_" + project.id}
                        >
                            <div className='title'>
                                <h4>
                                    {project.title}
                                </h4>
                                <p>
                                    {
                                        project.services.map((service, serviceIndex) => {
                                            return <Chip label={service} key={serviceIndex} variant='outlined' sx={{ margin: '3px' }} />
                                        })
                                    }
                                </p>
                            </div>
                            <div className='projectBGImage' style={{ backgroundImage: 'url("' + project.image + '")' }}>

                            </div>
                        </div>
                    ))}
                </div>
                <Link to="/portfolio" className='btnLink'>
                    All Projects
                </Link>
            </div>
            <div className='section mobileGallery bigBanner'>
                <h3>WORKS</h3>
                <div className='galleryList'>
                    {projects.map((project, projInd) => (
                        <div className='gallery-box-list'
                            onClick={() => {
                                setProjIndex(projInd)
                                setSelectedProject(project)
                                setShowGallery(true)
                            }}
                            key={"project_" + project.id}>
                            <div className='title'>
                                {project.title}
                            </div></div>
                    ))}
                </div>
            </div>
            <div className='section bigBanner quoteContainer'>
                <img loading="lazy" className='jackCard swingimage' aria-label='One Eyed Jack' alt='A One-Eyed Jack drawing that relates to a tattoo I have.' title="One Eyed Jack" src={jack} height={500} wdith={500} />
                <img loading="lazy" className='queen swingimage' title="Queen of Swords" alt='A Queen of Swords drawing that relates to a tattoo I have.' aria-label="Queen of Swords" src={queen} height={600} wdith={600} />
                <div className='quote quote1'>A jack of all trades</div>

                <div className='quote quote2'>is a master of none</div>

                <div className='quote quote1'>but oftentimes better</div>

                <div className='quote quote2'>than a master of one.</div>
            </div>
            <div className='section' id="services">
                <h3>SERVICES</h3>
                <Grid container className="serviceContainer" justifyContent='center'>

                    <Grid item xs={12} lg={6} xl={2} className="serviceCard">

                        <div className="serviceIcons">
                            <div className="w-96 h-96 bg-red-500 p-4" id="logo">
                                <div className='dot' id="dot1"></div>
                                <div className='dot' id="dot2"></div>
                                <div className='dot' id="dot3"></div>
                                <object title='Graphic Design Pen Icon' aria-label='Graphic Design Pen Icon' data={logoIcon} width="150" height="150" id="pen"> </object>
                                <object title='Graphic Design Grid' aria-label='Graphic Design Grid' data={gridIcon} width="250" height="250" id="logo-grid"> </object>

                            </div>
                        </div>
                        <h4>Graphic Design</h4>
                        <div className='serviceLines'>
                            <ul>
                                {
                                    allServices[0].serviceLists.map((services) => {
                                        return (
                                            <li>{services}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Grid>

                    <Grid item xs={12} lg={6} xl={2} className="serviceCard">

                        <div className="serviceIcons">
                            <div className="w-96 h-96 bg-red-500 p-4" id="user">
                                <div id='ux-holder'>
                                    <div id='headerPlaceholder'></div>
                                    <div className="menuBar" id='fakeNav'></div>
                                    <div className="menuBar" id='fakeNav1'></div>
                                    <div className="menuBar" id='fakeNav2'></div>

                                    <object title='User Experience Wireframe' id='wireframeImg' aria-label='User Experience WireFrame' data={userExpIcons} width="250" height="250"> </object>

                                    <object title='Placeholder Image for User interface' aria-label='Placeholder Image for User interface' data={userPic} width="150" height="150" id='userPic'></object>


                                    <div class='textRectangle' id="text2"></div>
                                    <div class='textRectangle' id="text3"></div>
                                    <div class='textRectangle' id="text4"></div>

                                    {/* <div class='textRectangle2' id="text6"></div>
                                    <div class='textRectangle2' id="text7"></div>
                                    <div class='textRectangle2' id="text8"></div> */}


                                    {/* <div id="uiBtn"></div> */}
                                    <object title='Placeholder Image for User interface' aria-label='Placeholder Image for User interface' data={placeholderIcon} width="175" height="150" className='placeholder'></object> {/* 
                                    <object title='Placeholder Image for User interface' aria-label='Placeholder Image for User interfacec' data={placeholderIcon} width="150" height="65" className='placeholder plce2'></object>
                                    <object title='Placeholder Image for User interface' aria-label='Placeholder Image for User interfacec' data={placeholderIcon} width="150" height="65" className='placeholder plce3'></object> */}
                                    <div id="computerBar"></div>
                                </div>

                            </div>

                        </div>
                        <h4>UI & UX Design</h4>
                        <div className='serviceLines'>
                            <ul>
                                {
                                    allServices[1].serviceLists.map((services) => {
                                        return (
                                            <li>{services}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Grid>

                    <Grid item xs={12} lg={6} xl={2} className="serviceCard">

                        <div className="serviceIcons">
                            <div className="w-96 h-96 bg-red-500 p-4" id="code" >
                                <span className='highlight bar'></span>
                                <span className='highlight2 bar' ></span>
                                <span className='highlight3 bar' ></span>
                                <span className='highlight4 bar' ></span>
                                <span className='highlight5 bar' ></span>
                                {/* <span className='highlight6 bar' ></span>
                                <span className='highlight7 bar' ></span>
                                <span className='highlight8 bar' ></span>
                                <span className='highlight9 bar' ></span> */}
                                <div>
                                    <svg aria-hidden="true" style={{ position: "absolute", width: 0, height: 0, overflow: 'hidden' }} version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                        <defs>
                                            <symbol id="icon-world" viewBox="0 0 216 100" title='icon-world' aria-label='icon-world' >
                                                <title>world</title>
                                                <g fillRule="nonzero"><path d="M48 94l-3-4-2-14c0-3-1-5-3-8-4-5-6-9-4-11l1-4 1-3c2-1 9 0 11 1l3 2 2 3 1 2 8 2c1 1 2 2 0 7-1 5-2 7-4 7l-2 3-2 4-2 3-2 1c-2 2-2 9 0 10v1l-3-2zM188 90l3-2h1l-4 2zM176 87h2l-1 1-1-1zM195 86l3-2-2 2h-1zM175 83l-1-2-2-1-6 1c-5 1-5 1-5-2l1-4 2-2 4-3c5-4 9-5 9-3 0 3 3 3 4 1s1-2 1 0l3 4c2 4 1 6-2 10-4 3-7 4-8 1zM100 80c-2-4-4-11-3-14l-1-6c-1-1-2-3-1-4 0-2-4-3-9-3-4 0-5 0-7-3-1-2-2-4-1-7l3-6 3-3c1-2 10-4 11-2l6 3 5-1c3 1 4 0 5-1s-1-2-2-2l-4-1c0-1 3-3 6-2 3 0 3 0 2-2-2-2-6-2-7 0l-2 2-1 2-3-2-3-3c-1 0-1 1 1 2l1 2-2-1c-4-3-6-2-8 1-2 2-4 3-5 1-1-1 0-4 2-4l2-2 1-2 3-2 3-2 2 1c3 0 7-3 5-4l-1-3h-1l-1 3-2 2h-1l-2-1c-2-1-2-1 1-4 5-4 6-4 11-3 4 1 4 1 2 2v1l3-1 6-1c5 0 6-1 5-2l2 1c1 2 2 2 2 1-2-4 12-7 14-4l11 1 29 3 1 2-3 3c-2 0-2 0-1 1l1 3h-2c-1-1-2-3-1-4h-4l-6 2c-1 1-1 1 2 2 3 2 4 6 1 8v3c1 3 0 3-3 0s-4-1-2 3c3 4 3 7-2 8-5 2-4 1-2 5 2 3 0 5-3 4l-2-1-2-2-1-1-1-1-2-2c-1-2-1-2-4 0-2 1-3 4-3 5-1 3-1 3-3 1l-2-4c0-2-1-3-2-3l-1-1-4-2-6-1-4-2c-1 1 3 4 5 4h2c1 1 0 2-1 4-3 2-7 4-8 3l-7-10 5 10c2 2 3 3 5 2 3 0 2 1-2 7-4 4-4 5-4 8 1 3 1 4-1 6l-2 3c0 2-6 9-8 9l-3-2zm22-51l-2-3-1-1v-1c-2 0-2 2-1 4 2 3 4 4 4 1z" /><path d="M117 75c-1-2 0-6 2-7h2l-2 5c0 2-1 3-2 1zM186 64h-3c-2 0-6-3-5-5 1-1 6 1 7 3l2 3-2-1zM160 62h2c1 1 0 1-1 1l-1-1zM154 57l-1-2c2 2 3 1 2-2l-2-3 2 2 1 4 1 3v2l-3-4zM161 59c-1-1-1-2 1-4 3-3 4-3 4 0 0 4-2 6-5 4zM167 59l1-1 1 1-1 1-1-1zM176 59l1-1v2l-1-1zM141 52l1-1v2l-1-1zM170 52l1-1v2l-1-1zM32 50c-1-2-4-3-6-4-4-1-5-3-7-6l-3-5-2-2c-1-3-1-6 2-9 1-1 2-3 1-5 0-4-3-5-8-4H4l2-2 1-1 1-1 2-1c1-2 7-2 23-1 12 1 12 1 12-1h1c1 1 2 2 3 1l1 1-3 1c-2 0-8 4-8 5l2 1 2 3 4-3c3-4 4-4 5-3l3 1 1 2 1 2c3 0-1 2-4 2-2 0-2 0-2 2 1 1 0 2-2 2-4 1-12 9-12 12 0 2 0 2-1 1 0-2-2-3-6-2-3 0-4 1-4 3-2 4 0 6 3 4 3-1 3-1 2 1s-1 2 1 2l1 2 1 3 1 1-3-2zm8-24l1-1c0-1-4-3-5-2l1 1v2c-1 1-1 1 0 0h3zM167 47v-3l1 2c1 2 0 3-1 1z" /><path d="M41 43h2l-1 1-1-1zM37 42v-1l2 1h-2zM16 38l1-1v2l-1-1zM172 32l2-3h1c1 2 0 4-3 4v-1zM173 26h2l-1 1-1-1zM56 22h2l-2 1v-1zM87 19l1-2 1 3-1 1-1-2zM85 19l1-1v1l-1 1v-1zM64 12l1-3c2 0-1-4-3-4s-2 0 0-1V3l-6 2c-3 1-3 1-2-1 2-1 4-2 15-2h14c0 2-6 7-10 9l-5 2-2 1-2-2zM53 12l1-1c2 0-1-3-3-3-2-1-1-1 1-1l4 2c2 1 2 1 1 3-2 1-4 2-4 0zM80 12l1-1 1 1-1 1-1-1zM36 8h-2V7c1-1 7 0 7 1h-5zM116 7l1-1v1l-1 1V7zM50 5h2l-1 1-1-1zM97 5l2-1c0-1 1-1 0 0l-2 1z" /></g>
                                            </symbol>
                                            <symbol id="icon-repeated-world" viewBox="0 0 432 100">
                                                <use href="#icon-world" x="0"></use>
                                                <use href="#icon-world" x="189"></use>
                                            </symbol>
                                        </defs>
                                    </svg>
                                    <div className="notice">
                                        <span className="world">
                                            <span className="images">
                                                <svg><use href="#icon-repeated-world"></use></svg>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <pre className='helloWorld'>Hello World!</pre>
                                {/* <div className='mobileTitle frontEnd'>
                                    <h4>Front-End Development</h4>
                                </div> */}
                            </div>
                        </div>
                        <h4>Front-End Development</h4>
                        <div className='serviceLines'>
                            <ul>
                                {
                                    allServices[2].serviceLists.map((services) => {
                                        return (
                                            <li>{services}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Grid>

                    <Grid item xs={12} lg={6} xl={2} className="serviceCard">

                        <div className="serviceIcons">
                            <div className="w-96 h-96 bg-red-500 p-4" id="arts">
                                <object aria-label='Paintbrush' title='Paintbrush' data={artsIcons} width="125" height="200" id="brush"> </object>
                                <object aria-label='Art Palette' title='Art Palette' data={paletteIcon} width="150" height="250" id="palatte"> </object>
                            </div>
                        </div>
                        <h4>Fine Art</h4>
                        <div className='serviceLines'>
                            <ul>
                                {
                                    allServices[3].serviceLists.map((services) => {
                                        return (
                                            <li>{services}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Grid>

                    <Grid item xs={12} lg={6} xl={2} className="serviceCard">

                        <div className="serviceIcons">
                            <div className="w-96 h-96 bg-red-500 p-4" id="motion">
                                <div id='ball'></div>
                                <object aria-label='Motion Graphics Slider' title='Motion Graphics Slider' data={motionSlider} id="slider" width="250" height="250"> </object>
                                <object aria-label='Motion Graphics Background' title='Motion Graphics Background' data={motionIcons} width="250" height="200"> </object>
                                {/* <div className='mobileTitle motionDesign'>
                                    <h4>Motion Design</h4>
                                </div> */}
                            </div>
                        </div>
                        <h4>Motion Design</h4>
                        <div className='serviceLines'>
                            <ul>
                                {
                                    allServices[4].serviceLists.map((services) => {
                                        return (
                                            <li>{services}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Grid>

                </Grid>

                <Box sx={{ marginTop: '50px', marginBottom: '100px' }}>
                    <Link to="/services" className='btnLink inverse'>
                        Learn More
                    </Link>
                </Box>
            </div>
            <div className='resume section' id="resume">
                <h3>CLIENTS</h3>
                <Grid container spacing={2} className='resumeList' justifyContent={'center'}>
                    {resumeJobs.map(job => (
                        <Grid item xs={12} lg={3} key={job.id + "_company"} className='resumeBtn'>
                            <div className='hover-content'>
                                <div className='company'>{job.company}</div>
                                <div className='title'>{job.title}</div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    )
}


const WordFader = ({ words, interval = 1500 }) => {
    const [currentWordIndex, setCurrentWordIndex] = React.useState(0);
    const [fadeIn, setFadeIn] = React.useState(true);

    useEffect(() => {
        const fadeInterval = setInterval(() => {
            setFadeIn(false);
            setTimeout(() => {
                setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
                setFadeIn(true);
            }, 500); // Duration of fade out animation
        }, interval);

        return () => clearInterval(fadeInterval);
    }, [words, interval]);

    return (
        <h2 className={`word ${fadeIn ? 'fade-in' : 'fade-out'} ${words[currentWordIndex]}`}>
            {words[currentWordIndex]}
        </h2>
    );
};